import { Injectable } from '@angular/core';
import LZString from 'lz-string';

@Injectable({
  providedIn: 'root',
})
export class CacheService {
  constructor() {}

  private generateCacheKey(url: string): string {
    return `cache_${url}`;
  }

  get(url: string): any | null {
    const key = this.generateCacheKey(url);
    const compressedCache = localStorage.getItem(key);
    if (!compressedCache) return null;

    try {
      const cachedString = LZString.decompress(compressedCache);
      const cached = JSON.parse(cachedString);

      if (new Date().getTime() > cached.expiry) {
        localStorage.removeItem(key);
        console.log(`[Cache Expired] ${key}`);
        return null;
      }
      return cached.response;
    } catch (e) {
      localStorage.removeItem(key);
      return null;
    }
  }

  /**
   * @param url API endpoint
   * @param response API response data
   * @param ttl Time to live in milliseconds
   */

  set(url: string, response: any, ttl: number): void {
    try {
      const key = this.generateCacheKey(url);
      const expiry = new Date().getTime() + ttl * 60 * 1000;
      const cached = {
        expiry,
        response,
      };
      const cachedString = JSON.stringify(cached);
      const compressedData = LZString.compress(cachedString);
      try {
        localStorage.setItem(key, compressedData);
      } catch (error) {
        console.error(`[Cache Set Error]`, error);
      }
    } catch (error) {
      console.error(`[Cache Set Error] Failed to set cache for key:`, error);
    }
  }

  clear(): void {
    Object.keys(localStorage)
      .filter((key) => key.startsWith('cache_'))
      .forEach((key) => localStorage.removeItem(key));
  }
}
